import db from '../../plugins/firebase'
import { collection, query, getDocs, addDoc, updateDoc, doc, where, limit } from "firebase/firestore"

const filterAll = async(filter) =>{
  const saidasRef = collection(db, "saidas");
  const params = []
  const saidaList = []

  if(filter && filter.periodos && filter.periodos.length)
    params.push(where("data_saida", "in", filter.periodos))

  if(filter && filter.idPessoa){
    params.push(where("pessoa.id", "==", filter.idPessoa))
  }
  if (filter && filter.idObra) {
    params.push(where("obra.id", "==", filter.idObra))
  }
  if (filter && filter.idEmpresa) {
    params.push(where("empresa.id", "==", filter.idEmpresa))
  }
  if(filter && filter.somenteEmpresas) {
    params.push(where("pessoa", "==", {}))
  }
  /*if (filter && filter.idCategoria) {
    params.push(where("categoria.id", "==", filter.idCategoria))
  }*/
  params.push(where("active", "==", true))
  let q = null
  if(filter.paginationLimit > 999){
    q = query(saidasRef, ...params);
  }else {
    q = query(saidasRef, ...params, limit(filter.paginationLimit));
  }
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    saidaList.push({
      id: doc.id,
      ...doc.data()
    })
  });
  return saidaList
}

const getBalanco = async(filter) =>{
  const saidasRef = collection(db, "saidas");
  const params = []
  const saidaList = []
  if(filter && filter.idPessoa){
    params.push(where("pessoa.id", "==", filter.idPessoa))
  }
  if (filter && filter.idObra) {
    params.push(where("obra.id", "==", filter.idObra))
  }
  params.push(where("active", "==", true))
  const q = query(saidasRef, ...params);
  const querySnapshot = await getDocs(q);
  querySnapshot.forEach((doc) => {
    // doc.data() is never undefined for query doc snapshots
    saidaList.push({
      id: doc.id,
      ...doc.data()
    })
  });
  return saidaList
}

const getAllSaidas = async () => {
  await filterAll();
  const querySnap = await getDocs(query(collection(db, 'saidas')));
  const saidaList = []
  querySnap.forEach((doc) => {
    saidaList.push({ id: doc.id, ...doc.data() })
  })
  return saidaList;
}

const saveSaida = async (payload) => {
  const colRef = collection(db, 'saidas')
  await addDoc(colRef, payload)
}

const updateSaida = async (payload) => {
  const colRef = await doc(db, 'saidas', payload.id);
  await updateDoc(colRef, payload);
}

const deleteSaida = async (payload) => {
  const colRef = await doc(db, 'saidas', payload.id);
  await updateDoc(colRef, {
    ...payload,
    active: false
  });
}

export { getAllSaidas, saveSaida, updateSaida, filterAll, deleteSaida, getBalanco }
